export { default as Img200 } from './processed/200/thurston_promo.jpg';
export { default as Img400 } from './processed/400/thurston_promo.jpg';
export { default as Img600 } from './processed/600/thurston_promo.jpg';
export { default as Img800 } from './processed/800/thurston_promo.jpg';
export { default as Img1000 } from './processed/1000/thurston_promo.jpg';
export { default as Imgthumb } from './processed/thumb/thurston_promo.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/thurston_promo.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/thurston_promo.jpg';
export const ImgData = { width: 1037, height: 516, ratio: 0.49758919961427195, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      180,
      148,
      44
    ],
    "_population": 1,
    "_hsl": [
      0.12745098039215685,
      0.6071428571428573,
      0.4392156862745098
    ]
  },
  "LightVibrant": {
    "_rgb": [
      222,
      202,
      137
    ],
    "_population": 227,
    "_hsl": [
      0.12745098039215683,
      0.5629139072847683,
      0.7039215686274509
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      107,
      88,
      26
    ],
    "_population": 0
  },
  "Muted": {
    "_rgb": [
      140,
      108,
      140
    ],
    "_population": 1,
    "_hsl": [
      0.8333333333333334,
      0.12903225806451618,
      0.4862745098039216
    ]
  },
  "LightMuted": {
    "_rgb": [
      148,
      180,
      196
    ],
    "_population": 1,
    "_hsl": [
      0.5555555555555556,
      0.2891566265060241,
      0.6745098039215687
    ]
  },
  "DarkMuted": {
    "_rgb": [
      68,
      68,
      68
    ],
    "_population": 112,
    "_hsl": [
      0,
      0,
      0.26666666666666666
    ]
  }
};



// WEBPACK FOOTER //
// ./src/content/images/thurston_promo.js